{
    "locale": "fr-FR"
}
